export const formatFilename = (file: File) => {
  const byteInMb = 1024 * 1024;
  const fileSizeInMB = (file.size / byteInMb).toFixed(2);
  const filename = `${file.name} - ( ${fileSizeInMB}MB )`;

  return filename;
};
